import React from "react";

/**
 * Premium intentional image placeholder.
 * Marked as "image slot" — meant to be replaced by real product photos later.
 */
export const ImageSlot = ({
  label = "Image",
  ratio = "aspect-[4/5]",
  src,
  alt,
  className = "",
  testId,
}) => {
  if (src) {
    return (
      <div
        className={`${ratio} w-full bg-white relative overflow-hidden ${className}`}
        data-testid={testId}
      >
        <img
          src={src}
          alt={alt || label}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-contain p-2"
        />
      </div>
    );
  }
  return (
    <div
      className={`${ratio} w-full bg-misty-surface border border-white/5 flex items-center justify-center relative overflow-hidden ${className}`}
      data-testid={testId}
    >
      <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-transparent to-white/[0.04]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(74,144,217,0.08),transparent_60%)]" />
      {/* Crosshair frame */}
      <div className="absolute top-3 left-3 w-4 h-px bg-white/15" />
      <div className="absolute top-3 left-3 w-px h-4 bg-white/15" />
      <div className="absolute top-3 right-3 w-4 h-px bg-white/15" />
      <div className="absolute top-3 right-3 w-px h-4 bg-white/15" />
      <div className="absolute bottom-3 left-3 w-4 h-px bg-white/15" />
      <div className="absolute bottom-3 left-3 w-px h-4 bg-white/15" />
      <div className="absolute bottom-3 right-3 w-4 h-px bg-white/15" />
      <div className="absolute bottom-3 right-3 w-px h-4 bg-white/15" />
      <div className="relative z-10 flex flex-col items-center gap-2">
        <div className="w-10 h-10 border border-white/15 rotate-45 flex items-center justify-center">
          <div className="w-2 h-2 bg-misty-steel rotate-45" />
        </div>
        <span className="text-misty-dim text-[10px] tracking-[0.3em] uppercase font-sans">
          {label}
        </span>
      </div>
    </div>
  );
};

/** Misty logotype slot (used in nav, hero, footer, age gate). */
export const MistyLogo = ({ size = "md", testId }) => {
  const sizes = {
    sm: "text-2xl",
    md: "text-3xl",
    lg: "text-6xl sm:text-7xl",
    xl: "text-7xl sm:text-8xl lg:text-9xl",
  };
  return (
    <div
      className="flex flex-col items-center leading-none select-none"
      data-testid={testId}
    >
      <span
        className={`font-display tracking-[0.04em] text-misty-text ${sizes[size]}`}
      >
        MISTY
      </span>
      <span
        className={`font-sans tracking-[0.5em] text-misty-steel ${
          size === "xl" || size === "lg"
            ? "text-sm sm:text-base mt-1"
            : "text-[10px] mt-0.5"
        }`}
      >
        DISTRIBUTION
      </span>
    </div>
  );
};
